import { Box, Icon, Typography } from "@husqvarna/ui-core";
import { FormattedMessage, useIntl } from "react-intl";
import "./MowerDialogStatusBar.scss";

export type MowerDialogStatusBarProps = {
  quantity: number;
  selectedAreasCount: number;
  hasCuttingQualityError: boolean;
  hasCapacityError: boolean;
};

const MowerDialogStatusBar = ({
  quantity,
  selectedAreasCount,
  hasCuttingQualityError,
  hasCapacityError,
}: MowerDialogStatusBarProps) => {
  const intl = useIntl();

  if (selectedAreasCount === 0) {
    return null;
  }

  return (
    <Box mx={6} mb={6} pt={6} className="mower-dialog-status-bar" flexDirection="column">
      {/* Success message */}
      <Box flexDirection="row" gap={3}>
        <Icon iconId="check-filled" size={5} color="SuccessGreen" />
        <Typography className="status-message" variant="Microcopy">
          <FormattedMessage
            id="project.equipment.mowersAdded"
            defaultMessage="{mowerCount} mower added to {areaCount} areas"
            values={{
              mowerCount: <span className="bold">{quantity}</span>,
              areaCount: <span className="bold">{selectedAreasCount}</span>,
            }}
          />
        </Typography>
      </Box>

      {/* Error messages */}
      {hasCuttingQualityError && (
        <Box flexDirection="row" className="warning-message visible" gap={3}>
          <Icon iconId="info" size={5} color="ErrorRed" className="icon-warning" />
          <Typography
            variant="Microcopy"
            color="ErrorRed"
            text={intl.formatMessage({
              id: "project.equipment.mowerAreaQualityError",
              defaultMessage: "Cannot handle multiple cutting qualities",
            })}
          />
        </Box>
      )}

      {hasCapacityError && (
        <Box flexDirection="row" className="warning-message visible" gap={3}>
          <Icon iconId="info" size={5} color="ErrorRed" className="icon-warning" />
          <Typography
            variant="Microcopy"
            color="ErrorRed"
            text={intl.formatMessage({
              id: "project.equipment.mowerCapacityError",
              defaultMessage: "Exceeds remaining capacity",
            })}
          />
        </Box>
      )}
    </Box>
  );
};

export default MowerDialogStatusBar;
